/*
 * @name: 
 * @Author: zxc
 * @Date: 2021-01-28 14:01:40
 * @LastEditors: zxc
 * @LastEditTime: 2021-10-12 14:59:48
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 这里面文件导入顺序决定样式的覆盖
import Vue from 'vue'
import router from './router'

import Element from 'element-ui'
Vue.use(Element, {
  size: Cookies.get('size') || 'mini'
})

import 'element-ui/lib/theme-chalk/index.css'
import './assets/fonts/iconfont.css'

import '@/styles/index.scss' // global css

import animated from 'animate.css'
Vue.use(animated)

// 验证滑块
import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.use(SlideVerify)

import qs from 'qs'
Vue.prototype.$qs = qs

import Loading from '@/components/loading.js'
Vue.use(Loading)

import './icons' // icon

// import '@/styles/index.scss' // global css.

import App from './App'
import store from './store'

import ECharts from 'vue-echarts/components/ECharts'
Vue.component('chart', ECharts)

// 引入mqtt
import './mq'
import Cookies from 'js-cookie'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js